import PropTypes from "prop-types"
import React from "react"

// Brand marks for the social platforms, drawn on a 24 by 24 grid in the
// current text color.
export const SOCIAL_ICONS = {
  TikTok: (
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  ),
  YouTube: (
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  ),
  Instagram: (
    <>
      <rect
        fill="none"
        height="18"
        rx="5"
        stroke="currentColor"
        strokeWidth="2.2"
        width="18"
        x="3"
        y="3"
      />
      <circle
        cx="12"
        cy="12"
        fill="none"
        r="4.2"
        stroke="currentColor"
        strokeWidth="2.2"
      />
      <circle cx="17.4" cy="6.6" r="1.4" />
    </>
  ),
  Facebook: (
    <path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.6 1.6-1.6h1.7V4.4c-.3 0-1.3-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2v2.3H7.4V14h2.8v8h3.3z" />
  ),
  LinkedIn: (
    <>
      <circle cx="5" cy="5" r="2.3" />
      <rect height="12" width="4.2" x="2.9" y="8.5" />
      <path d="M9.6 8.5h4v1.7c.6-1 1.9-2 3.9-2 4.1 0 4.5 2.7 4.5 6.1v6.2h-4.2v-5.5c0-1.4 0-3.1-1.9-3.1s-2.2 1.5-2.2 3v5.6H9.6z" />
    </>
  ),
}

// Works out the platform from a link's URL, then from its text (the footer
// labels them FB, IG, YT and TikTok).
export const getSocialPlatform = (path = "", text = "") => {
  const value = `${path} ${text}`.toLowerCase()
  if (/tiktok/.test(value)) return "TikTok"
  if (/youtube|youtu\.be|\byt\b/.test(value)) return "YouTube"
  if (/instagram|\big\b/.test(value)) return "Instagram"
  if (/facebook|\bfb\b/.test(value)) return "Facebook"
  if (/linkedin/.test(value)) return "LinkedIn"
  return null
}

const SocialIcon = ({ name, size = 20 }) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height={size}
    viewBox="0 0 24 24"
    width={size}
  >
    {SOCIAL_ICONS[name]}
  </svg>
)

SocialIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(SOCIAL_ICONS)).isRequired,
  size: PropTypes.number,
}

export default SocialIcon
